import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CalendarDays } from "lucide-react";
import { fmtDateShort } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

export default function Schichten() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/shifts").then((r) => setRows(r.data || []));
  }, []);

  const upcoming = rows
    .filter((r) => r.date >= new Date().toISOString().slice(0, 10))
    .sort((a, b) => a.date.localeCompare(b.date));

  return (
    <div>
      <PageHeader title="Meine Schichten" subtitle="Deine geplanten Einsätze." testid="schichten-header" />
      <div className="grid gap-3 max-w-2xl">
        {upcoming.length === 0 ? (
          <Card className="border-slate-200 rounded-xl"><EmptyState icon={CalendarDays} title="Keine geplanten Schichten" testid="schichten-empty" /></Card>
        ) : (
          upcoming.map((r) => (
            <Card key={r.id} className="p-4 border-slate-200 rounded-xl flex items-center justify-between" data-testid={`shift-row-${r.id}`}>
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg brand-bg/10 flex items-center justify-center brand-text bg-slate-100">
                  <CalendarDays className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-medium text-slate-900">{fmtDateShort(r.date)}</div>
                  {r.note && <div className="text-sm text-slate-500">{r.note}</div>}
                </div>
              </div>
              <div className="font-mono text-slate-900">{r.start} – {r.end}</div>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
